import React from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { CircularProgress, withStyles } from 'material-ui';
import Slider from 'react-slick';

const styles = theme => ({
    progressIndicator: {
        margin: '0 auto',
        paddingLeft: '40%',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '100%',
        boxSizing: 'border-box !important',
        width: '100%',
        height: '400px',
        marginBottom: '25px',
    },
    imageContainer: {
        height: '400px',
        maxHeight: '400px',
    },
});

class ResultCardPhotos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imagesPreloaded: [],
            loaded: false,
        };
    }

    componentDidMount() {
        let loadSingleImage = src => {
            return new Promise((resolve, reject) => {
                let img = new Image();
                img.onload = () => resolve(img.height);
                img.onerror = reject;
                img.src = src;
            });
        };
        let preProcessed = this.props.images.map(async url => {
            try {
                const height = await loadSingleImage(url);
                if (height && height > 0) {
                    return url;
                }
            } catch (e) {
                console.error(e, `invalid url ${url}`);
            }
        });
        Promise.all(preProcessed).then(url => {
            this.setState({
                imagesPreloaded: url.filter(u => u),
                loaded: true,
            });
        });
    }

    render() {
        const { classes } = this.props;
        const settings = {
            dots: true,
            infinite: true,
            speed: 200,
            slidesToShow: 1,
            slidesToScroll: 1,
        };

        return this.state.loaded
            ?
            <div>
                <Slider {...settings}>
                    {this.state.imagesPreloaded.map(imgUrl => {
                        return (
                            <div key={imgUrl} className={classes.imageContainer}>
                                <img src={imgUrl} alt='Hotel' className={classes.image} />
                            </div>
                        );
                    })}
                </Slider>
            </div>
            :
            <div className={classes.progressIndicator}>
                <CircularProgress />
            </div>;
    }
}

export default withStyles(styles)(ResultCardPhotos);



// WEBPACK FOOTER //
// ./src/components/Results/ResultCardPhotos.js